import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Login from "./components/pages/login/Login";
import { ThemeProvider } from "@mui/material/styles";
import CustomTheme from "./components/common/theme";
import { Box, Paper } from "@mui/material";
import Dashboard from "./components/pages/Dashboard";
import Instructions from "./components/pages/Instructions";
import Homework from "./components/pages/Homework";
import { useCharactersContext } from "./components/hooks/Context";
import { useEffect } from "react";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import Lessons from "./components/pages/Lessons";
import Levels from "./components/pages/Levels";
import Modules from "./components/pages/Modules";
import TopMenu from "./components/layouts/TopMenu";

function App() {
  const { showLogin, setShowLogin } = useCharactersContext();
  const location = useLocation();

  useEffect(() => {
    if (localStorage.getItem("accessToken")) {
      setShowLogin(true);
    }
  }, []);

  let marginTopValue = "0vh"; // Default margin value

  if (location.pathname === "/dashboard") {
    marginTopValue = "70px";
  } else if (location.pathname === "/instructions") {
    marginTopValue = "10.5vh";
  } else if (location.pathname === "/modules") {
    marginTopValue = "3vh";
  }
  console.log("marginTopValue", marginTopValue);

  return (
    <DndProvider backend={TouchBackend}>
      <ThemeProvider theme={CustomTheme}>
        <Paper>
          {!showLogin ? (
            <>
              <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login/:userName/:userpassword" element={<Login />} />
                <Route path="/login" element={<Login />} /> 
              </Routes>
              
            </>
          ) : (
            <>
              <TopMenu />
              <Box sx={{ marginTop: marginTopValue }}>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/instructions" element={<Instructions />} />
                  <Route path="/modules" element={<Modules />} />
                  <Route
                    path="/modules/:moduleId/levels"
                    element={<Levels />}
                  />
                  <Route
                    path="/modules/:moduleId/levels/:levelId/lessons"
                    element={<Lessons />}
                  />
                  <Route
                    path="/modules/:moduleId/levels/:levelId/lessons/:lessonId"
                    element={<Homework />}
                  />
                </Routes>
              </Box>
            </>
          )}
        </Paper>
      </ThemeProvider>
    </DndProvider>
  );
}

export default App;
